import { ex } from "@fullcalendar/core/internal-common";

export enum CustomerLabelColumn{
    externOrderKey = 'externOrderKey',
    facility = 'facility',
    deliveryId = 'deliveryId',
    labelKey = 'labelKey',
    idFromCu = 'idFromCu',
    ouser2 = 'ouser2',
    externLineNumber = 'externLineNumber',
    buyerPo = 'buyerPo',
    soLineNo = 'soLineNo',
    sku = 'sku',
    altSku = 'altSku',
    altSkuDescr = 'altSkuDescr',
    altSkuSpecDescr = 'altSkuSpecDescr',
    docSku = 'docSku',
    externWorkOrder = 'externWorkOrder',
    retailSku = 'retailSku',
    custLabel01 = 'custLabel01',
    custLabel02 = 'custLabel02',
    custLabel03 = 'custLabel03',
    custLabel04 = 'custLabel04',
    custLabel05 = 'custLabel05',
    glAttribute01 = 'glAttribute01',
    glAttribute02 = 'glAttribute02',
    glAttribute03 = 'glAttribute03',
    glAttribute04 = 'glAttribute04',
    glAttribute05 = 'glAttribute05'
}


export class QueryCustomerLabelRequest {
    externOrderKey!: string;
    userDataScopes!: any;
}
 
export class QueryCustomerLabelResponse {
    header!: CustomerLabelHeader;
    details!: CustomerLabelDetail[];
}

export class CustomerLabelHeader{
    externOrderKey!: string;
    facility: string | undefined ;
    deliveryId: string | undefined ;
    labelKey: number | undefined ;
    idFromCu: string | undefined ;
    ouser2: string | undefined ;
}
export class CustomerLabelHeaderRowData{
    seqNo: number | undefined ;
    externOrderKey!: string;
    facility: string | undefined ;
    deliveryId: string | undefined ;
    labelKey: number | undefined ;
    idFromCu: string | undefined ;
    ouser2: string | undefined ;
}
export class CustomerLabelDetailRowData{
    seqNo: number | undefined ;
    externLineNumber!: string ;
    buyerPo: string | undefined ;
    soLineNo: string | undefined ;
    sku: string | undefined ;
    altSku: string | undefined ;
    altSkuDescr: string | undefined ;
    altSkuSpecDescr: string | undefined ;
    docSku: string  | undefined ;
    externWorkOrder: string | undefined ;
    retailSku: string | undefined ;
    isCustLabelEditable!: boolean
    custLabel01: string | undefined ;
    custLabel02: string | undefined ;
    custLabel03: string | undefined ;
    custLabel04: string | undefined ;
    custLabel05: string | undefined ;
    glAttribute01: string | undefined ;
    glAttribute02: string | undefined ;
    glAttribute03: string | undefined ;
    glAttribute04: string | undefined ;
    glAttribute05: string | undefined ;
}
export class CustomerLabelDetail{
    seqNo: number | undefined ;
    externLineNumber!: string ;
    buyerPo: string | undefined ;
    soLineNo: string | undefined ;
    sku: string | undefined ;
    altSku: string | undefined ;
    altSkuDescr: string | undefined ;
    altSkuSpecDescr: string | undefined ;
    docSku: string  | undefined ;
    externWorkOrder: string | undefined ;
    retailSku: string | undefined ;
    isCustLabelEditable!: boolean
    custLabel01: string | undefined ;
    custLabel02: string | undefined ;
    custLabel03: string | undefined ;
    custLabel04: string | undefined ;
    custLabel05: string | undefined ;
    glAttribute01: string | undefined ;
    glAttribute02: string | undefined ;
    glAttribute03: string | undefined ;
    glAttribute04: string | undefined ;
    glAttribute05: string | undefined ;
}

export class UpdateCustomerLabelHeaderRequest{
    userId!: string;
    customerLabelHeader!: CustomerLabelHeader;
}
export class UpdateCustomerLabelDetailRequest{
    userId!: string;
    externOrderKey!: string;
    customerLabelDetail!: CustomerLabelDetail[];
}

export class SendCustomerLabelRequest {
    externOrderKey!: string;
}